import { BaseListFilter } from '../../../models/base-list-filter.model';

export class DiscountsFilter extends BaseListFilter {
  isDisabled?: boolean = false;
  description?: string;
  key?: string;
  search?: string;
  createdAtFrom?: Date;
  createdAtTo?: Date;
}
